import React from "react";

import { Box, Typography } from "@mui/material";
import { withStyles } from "tss-react/mui";

import NoExercisesIcon from "@/components/Icons/NoExercisesIcon";

import Spacer from "../../../../../../components/layout/Spacer";

const Container = withStyles(Box, {
  root: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "center",
  },
});

const StyledNoExercisesIcon = withStyles(NoExercisesIcon, {
  root: {
    width: 33.89,
    height: 34.69,
  },
});

const NoExercisesText = withStyles(Typography, {
  root: {
    color: "#AAB0BB",
    fontSize: 14,
    fontWeight: 600,
  },
});

const EmptyView: React.FC = () => {
  return (
    <Container>
      <StyledNoExercisesIcon />
      <Spacer y={15.81} px />
      <NoExercisesText>No exercise details yet</NoExercisesText>
    </Container>
  );
};

export default EmptyView;
